import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Container, Fab, Stack, TextField, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { invoicePaymentPO, grnPO } from './_mock/user';
import { DataGrid } from '@mui/x-data-grid';
import { sendInvoiceToSAPForPayment } from './paymentAPIs';
import { PAYMENT_ROLES, PROD } from '../../common/constants';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import { format } from 'date-fns';
import { VALIDATION, capitalizeFunction, openTextFieldMaxLength } from '../../common/commonValidations';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { useTranslation } from "react-i18next";

function InvoicePaymentVerify() {
    const rows = invoicePaymentPO;
    const GRNrows = grnPO
    const { t } = useTranslation();
    const columns = [
        { field: 'pitPono', headerName: 'PO Number', width: 150 },
        { field: 'stakeholderName', headerName: 'Stakeholder Name', width: 200 },
        {
            field: 'poDescription', headerName: 'Description', width: 350,
            renderCell: (params) => {
                return (
                    <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
                        {params.value.split('<br />').map((line, index) => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </div>
                )
            }
        },
        {
            field: 'poAmount', headerName: 'PO Amount', width: 150, type: "number",
            valueGetter: (params) => params.value?.toFixed(2)
        },
        {
            field: 'poDate', headerName: 'PO Date', width: 150, type: "date",
            renderCell: (params) => {
                return (
                    <>{params?.value ? format(new Date(params?.value), 'dd/MM/yyyy') : null}</>
                )
            }
        },
        { field: 'paymentCycle', headerName: 'Payment Cycle', width: 150 },
        {
            field: 'quantity', headerName: 'Quantity(MT)', width: 100, type: "number",
            valueGetter: (params) => params.value?.toFixed(2)
        },
        {
            field: 'rateAmount', headerName: 'Rate', width: 100, type: "number",
            valueGetter: (params) => params.value?.toFixed(2)
        },
        {
            field: 'gstTaxAmount', headerName: 'GST/Tax %(if any)', width: 100, type: "number",
            valueGetter: (params) => params.value?.toFixed(2)
        }
    ];

    const GRNColumns = [
        { field: 'pitGrnSesNumber', headerName: 'GRN/SES Number', width: 150 },
        { field: 'pitGrnSesQuantity', headerName: 'GRN/SES Quantity', width: 150 },
        {
            field: 'pitGrnSesDate', headerName: t('reg.date'), width: 150,
            renderCell: (params) => {
                return (
                    <>{params?.value ? format(new Date(params?.value), 'dd/MM/yyyy') : null}</>
                )
            }
        },
    ]

    const auth = 'Bearer ' + getLocalStorageItem('id_token');
    const { state } = useLocation();
    console.log("state?.selectedRow", state?.selectedRow)
    const [dialogOpen, setDialogOpen] = useState(false);
    const [actionText, setActionText] = useState();
    const [comment, setComment] = useState();
    const [documents, setDocuments] = useState([]);

    const [actionRespone, setActionResponse] = useState([]);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setComment(VALIDATION.noSpecialCharacterValidation(e.target.value))
    }

    const handleClose = () => {
        setDialogOpen(false);
    };

    const onSendToSAP = () => {
        setActionText("Send to SAP for payment");
        setDialogOpen(true);
    }

    function onConfirmSendToSAP() {
        setDialogOpen(false);
        const tempArr = [];
        tempArr.push({
            paymentId: state?.selectedRow?.id,
            documents: [],
        })
        sendInvoiceToSAPForPayment(tempArr, setActionResponse, comment, null, navigate);
    }


    return (
        <>
            {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>PAY06</p>}
            <Helmet>
                <title> Invoice Payment </title>
            </Helmet>
            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab onClick={() => { navigate('../invoicePayment') }} size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab> Invoice Payment
                </Typography>
                <Card>
                    <CardContent>
                        <Stack spacing={2} sx={{ pt: 1 }}>
                            <Card>
                                {/* <Box sx={{ width: '100%' }}> */}
                                <DataGrid
                                    autoHeight
                                    rows={[state?.selectedRow]}
                                    columns={columns}
                                    getRowHeight={() => 'auto'}
                                    pageSize={10}
                                    components={{
                                        Toolbar: CustomDataGridToolbar,
                                    }}
                                    componentsProps={{ toolbar: { rows: [state?.selectedRow], columns: columns, fileName: "Invoice Payment.xlsx" } }}
                                />
                                {/* </Box> */}
                            </Card>
                            <Card>
                                {/* <Box style={{ height: 220, width: '100%' }}> */}
                                <DataGrid
                                    autoHeight
                                    rows={[state?.selectedRow]}
                                    columns={GRNColumns}
                                    pageSize={10}
                                    getRowHeight={() => 'auto'}
                                    components={{
                                        Toolbar: CustomDataGridToolbar,
                                    }}
                                    componentsProps={{ toolbar: { rows: [state?.selectedRow], columns: GRNColumns, fileName: "Invoice Payment.xlsx" } }}
                                />
                                {/* </Box> */}
                            </Card>
                            <TextField fullWidth
                                disabled
                                label="Invoice Number"
                                color="info"
                                rows={5}
                                name="invoice Number"
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                // onChange={(e) => handleChange(e)}
                                value={state?.selectedRow?.pitInvoiceNumber}
                                sx={{ width: "30%" }}
                            />
                            <TextField fullWidth
                                disabled
                                autoComplete="off"
                                label="Total Invoice Amount (INR)"
                                color="info"
                                rows={5}
                                // name="remark"
                                // onChange={(e) => handleChange(e)}
                                value={state?.selectedRow?.totalInvoiceAmount}
                                sx={{ width: "30%" }}
                            />
                            {<>
                                {/* <TextField fullWidth
                                disabled
                                autoComplete="off"
                                label="Reviewer's Remark"
                                color="info"
                                rows={5}
                                multiline
                                // name="approveAmount"
                                // onChange={(e) => handleChange(e)}
                                value={state?.selectedRow?.reviewerRemark}
                                sx={{ width: "60%" }}
                            /> */}
                                <TextField fullWidth
                                    autoComplete="off"
                                    disabled={state?.selectedRow?.status !== "InvoiceReceived" || localStorage.getItem('role') === PAYMENT_ROLES.SCMEndUser}
                                    label="Approver's Remark"
                                    color="info"
                                    rows={5}
                                    multiline
                                    inputProps={{
                                        maxLength: openTextFieldMaxLength
                                    }}
                                    name="approveRemark"
                                    onChange={(e) => handleChange(e)}
                                    value={comment}
                                    sx={{ width: "60%" }}
                                /></>}
                        </Stack>

                        &nbsp;
                        &nbsp;
                        {state?.selectedRow?.status === "InvoiceReceived" && state?.selectedRow.sapPoNumber && state?.selectedRow.sapGrnSesNumber && <Box display='flex' alignItems="center" justifyContent="center">
                            <Button sx={{ minWidth: 120 }} onClick={() => onSendToSAP()} variant="contained" disabled={localStorage.getItem('role') === PAYMENT_ROLES.SCMEndUser} >Send to SAP for payment</Button>
                        </Box>}
                    </CardContent>
                </Card>
            </Container>
            <ConfirmationPopover
                onOpen={Boolean(dialogOpen)}
                onClose={handleClose}
                onConfirm={onConfirmSendToSAP}
                action={actionText}
            />
        </>
    )
}

export default InvoicePaymentVerify